import React from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import EvaluationFormula from "presentation/pages/evaluation-schemes/elements/evaluation-formula/evaluation-formula";
import { STAGE_FORMULA_TYPE_CUSTOM, STAGE_FORMULA_TYPE_DEFAULT, stageFormulaTypes, TERM_INFO_ITEM_TYPE_EVALUATION_PERIOD } from "presentation/model/constants";


import {
    handleFieldChange as handleStageFieldChange, handleChangeStages
} from 'presentation/pages/evaluation-schemes/functions/stages';

import { isNullOrEmpty } from "presentation/utils/functions/generic";

class StageFormulasTabEvaluationSchemeForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            terms: []
        };
    }

    componentDidMount() {
        this.loadTerms();
    }

    componentDidUpdate(prevProps, prevState) {
        const { periods } = this.props;
        const { periods: previousPeriodsParam } = prevProps;

        if (periods != previousPeriodsParam) {
            this.loadTerms();
        }
    }

    loadTerms = () => {
        let { periods } = this.props;
        let terms = periods.map((p, pi) => {
            return { stageId: p.stageId, id: p.id, displayName: p.name, machineName: `period:${p.id}`, isUnique: true, termInfoItemType: TERM_INFO_ITEM_TYPE_EVALUATION_PERIOD };
        });
        this.setState({ terms: terms });
    }

    updateExpression = (entityKey, elements) => {
        const { component } = this.props;
        handleStageFieldChange(entityKey, 'periodsFormula', elements, component);
    }

    render() {
        let { component, stages } = this.props;
        let { terms } = this.state;
        let { updateExpression } = this;
        const validStages = stages.filter(x => x.name && !isNullOrEmpty(x.name) && !(x.isDeleteRequested && x.isDeleteRequested == true));

        return (
            <Container>
                <Row>
                    <Col>
                        <h4>Fórmula das etapas</h4>
                    </Col>
                </Row>
                {validStages.map((e, i) => {
                    let stageKey = e.key;
                    let periodsFormulaType = e.periodsFormulaType || STAGE_FORMULA_TYPE_DEFAULT;
                    let stageTerms = terms.filter(x => x.stageId == e.id);
                    let existingElements = e.periodsFormula || [];
                    return (
                        <div className="mb-4" key={`stage-formula-${stageKey}`}>
                            <Container>
                                <Row>
                                    <Col lg={12}><h5>{e.name}</h5></Col>
                                    <div className="form mb-2">
                                        <Form.Label htmlFor="periodsFormulaType">Para calcular o resultado dessa etapa, vou utilizar:</Form.Label>
                                        <Form.Select
                                            aria-label="Para calcular o resultado dessa etapa, vou utilizar:"
                                            defaultValue={periodsFormulaType}
                                            id={`periodsFormulaType`}
                                            name={`periodsFormulaType`}
                                            data-field-name="periodsFormulaType"
                                            onChange={(e) => handleChangeStages(stageKey, e, component)}
                                            required
                                        >
                                            <option key="-1">Selecione</option>
                                            {stageFormulaTypes.map((e, i) => { return <option key={e.id} value={e.id}>{e.name}</option> })}
                                        </Form.Select>
                                    </div>
                                </Row>
                            </Container>
                            {
                                parseInt(e.periodsFormulaType) == STAGE_FORMULA_TYPE_CUSTOM && (
                                    <EvaluationFormula component={component} entityKey={stageKey} sortableKey={`ev-stage-${stageKey}`} updateExpression={updateExpression} terms={stageTerms} existingElements={existingElements} />
                                )
                            }
                            <hr />
                        </div>
                    );
                })
                }
            </Container >
        );
    };
}

export default StageFormulasTabEvaluationSchemeForm;